import { AlignCenterHorizontalIcon } from '../../../../../svg/align-center-horizontal-icon';
import { AlignEndHorizontalIcon } from '../../../../../svg/align-end-horizontal-icon';
import { AlignEndVerticalIcon } from '../../../../../svg/align-end-vertical-icon';
import { AlignStartHorizontalIcon } from '../../../../../svg/align-start-horizontal-icon';
import { AlignStartVerticalIcon } from '../../../../../svg/align-start-vertical-icon';
import { AlignVerticalJustifyCenterIcon } from '../../../../../svg/align-vertical-justify-center-icon';

import { Button } from '../../../../../primitives/button';
import { ButtonGroup } from '../../../../../primitives/button-group';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { cn } from '../../../../../utils/cn';

import { HorizontalAlignment } from '../../constants/horizontal-alignment';
import { VerticalAlignment } from '../../constants/vertical-alignment';

type AlignmentProps = {
  className?: string;
  horizontalAlignment?: HorizontalAlignment;
  isHorizontalAlignmentVisible?: boolean;
  isVerticalAlignmentVisible?: boolean;
  verticalAlignment?: VerticalAlignment;
  onHorizontalAlignmentChange?: (alignment: HorizontalAlignment) => void;
  onVerticalAlignmentChange?: (alignment: VerticalAlignment) => void;
};

export function Alignment({
  className,
  horizontalAlignment,
  isHorizontalAlignmentVisible,
  isVerticalAlignmentVisible,
  verticalAlignment,
  onHorizontalAlignmentChange,
  onVerticalAlignmentChange,
}: AlignmentProps) {
  if (!isHorizontalAlignmentVisible && !isVerticalAlignmentVisible) {
    return null;
  }

  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Alineación</p>
      <div className="grid grid-cols-2 gap-4">
        {isHorizontalAlignmentVisible && (
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Horizontal
            </LabelWithoutRef>
            <ButtonGroup className="w-full">
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': horizontalAlignment === 'left',
                })}
                title="Alinear a la izquierda"
                variant="outline"
                size="sm"
                onClick={() => onHorizontalAlignmentChange?.('left')}
              >
                <AlignStartVerticalIcon />
              </Button>
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': horizontalAlignment === 'center',
                })}
                title="Alinear al centro horizontalmente"
                variant="outline"
                size="sm"
                onClick={() => onHorizontalAlignmentChange?.('center')}
              >
                <AlignVerticalJustifyCenterIcon />
              </Button>
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': horizontalAlignment === 'right',
                })}
                title="Alinear a la derecha"
                variant="outline"
                size="sm"
                onClick={() => onHorizontalAlignmentChange?.('right')}
              >
                <AlignEndVerticalIcon />
              </Button>
            </ButtonGroup>
          </div>
        )}
        {isVerticalAlignmentVisible && (
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Vertical
            </LabelWithoutRef>
            <ButtonGroup className="w-full">
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': verticalAlignment === 'top',
                })}
                title="Alinear arriba"
                variant="outline"
                size="sm"
                onClick={() => onVerticalAlignmentChange?.('top')}
              >
                <AlignStartHorizontalIcon />
              </Button>
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': verticalAlignment === 'middle',
                })}
                title="Alinear enmedio verticalmente"
                variant="outline"
                size="sm"
                onClick={() => onVerticalAlignmentChange?.('middle')}
              >
                <AlignCenterHorizontalIcon />
              </Button>
              <Button
                className={cn('w-full', {
                  'bg-accent/80 text-accent-foreground': verticalAlignment === 'bottom',
                })}
                title="Alinear abajo"
                variant="outline"
                size="sm"
                onClick={() => onVerticalAlignmentChange?.('bottom')}
              >
                <AlignEndHorizontalIcon />
              </Button>
            </ButtonGroup>
          </div>
        )}
      </div>
    </div>
  );
}
